import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatTooltip } from "@angular/material/tooltip";

export type ExcelExportSize = "big" | "medium" | "small";

/**
 * Bouton dédié à l'export Excel — palette verte (couleur Excel/tableur),
 * icône `table_view` + libellé clair "Exporter vers Excel". 3 tailles :
 *  - `big`     : carte pleine, pour empty states / actions principales
 *  - `medium`  : pill, pour barres d'outils (taille par défaut)
 *  - `small`   : icône seule + tooltip, pour les listes d'actions inline
 */
@Component({
  selector: "vl-excel-export-button",
  standalone: true,
  imports: [MatIcon, MatProgressSpinner, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./excel-export-button.component.html",
  styleUrl: "./excel-export-button.component.scss",
})
export class ExcelExportButtonComponent {
  size = input<ExcelExportSize>("medium");
  loading = input(false);
  disabled = input(false);
  /** Texte affiché — par défaut "Exporter vers Excel".
   *  Ignoré en mode `small` (icône seule). */
  text = input<string>("Exporter vers Excel");
  /** Tooltip — utilisé en `small` ou si défini. */
  tooltip = input<string>("Exporter vers Excel");
  /** Override icône Material (par défaut `table_view`). */
  icon = input<string>("table_view");

  action = output<void>();

  isDisabled = computed(() => this.disabled() || this.loading());
  containerClass = computed(
    () => `xls-btn xls-btn-${this.size()}${this.isDisabled() ? " xls-btn-disabled" : ""}`,
  );

  spinnerSize = computed(() =>
    this.size() === "big" ? 24 : this.size() === "small" ? 16 : 18,
  );

  onClick(event: MouseEvent) {
    event.stopPropagation();
    if (this.isDisabled()) return;
    this.action.emit();
  }
}
